//components
import { Button, Typography, Row, Col } from "antd";
import { useSelector } from "react-redux";
import placeholder from "../../../../../asset/img/placeholder.png";
import { branchDetailBySlugSelector } from "../../../../../store/branch/branch.selector";
import branchBookingImg from "../../../../../asset/img/makeup-booking.png";
import bookNow from "../../../../../asset/img/book.png";
import freeConsult from "../../../../../asset/img/consultation.png";
//actions
//selector
//function
//str

export const BranchBooking = ({ mobile, tablet }) => {
  const paddingValue = mobile ? "20px 10px" : "50px 20px";
  const btnWidth = mobile ? "100%" : "90%";
  const handleBook = () => {
    const url = `${window.location.href}/booking`;
    window.open(url, "_blank");
  };
  const handleConsult = () => {
    const url = `${window.location.href}/consultation`;
    window.open(url, "_blank");
  };

  return (
    // outer container (centers card)
    <div style={{ width: "100%", maxWidth: 400, margin: "0 auto", padding: 0 }}>
      {/* card container with rounded corners and overflow hidden */}
      <div
        style={{
          border: "10px solid #4A2C04",
          borderRadius: 20,
          overflow: "hidden",
          backgroundColor: "#eadbcc",
        }}
      >
        <img
          src={branchBookingImg || placeholder}
          alt="Book Now"
          style={{ width: "100%", display: "block" }}
        />

        <div
          style={{
            padding: paddingValue,
          }}
        >
          <Row gutter={[12, 12]}>
            <Col
              span={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={bookNow || placeholder}
                alt="Book Now"
                style={{ width: btnWidth, display: "block" }}
                onClick={handleBook}
              />
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={freeConsult || placeholder}
                alt="Book Now"
                style={{ width: btnWidth, display: "block" }}
                onClick={handleConsult}
              />
            </Col>
          </Row>

          {/* <Row gutter={[12, 0]}>
            <Col
              span={6}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            ></Col>
            <Col
              span={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={bookNow || placeholder}
                alt="Book Now"
                style={{ width: btnWidth, display: "block" }}
                onClick={handleBook}
              />
            </Col>
            <Col
              span={5}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            ></Col>
          </Row> */}
        </div>
      </div>
    </div>
  );
};

export default BranchBooking;
